import { RootState } from '@store/index';
import { analysisRequestFromInput } from '../../services/drbfm.analysis';

// ==============================================================================
// Selectors
// ==============================================================================

// Session selectors
export const selectSessions = (state: RootState) => state.drbfm.sessions;
export const selectCurrentSession = (state: RootState) => state.drbfm.currentSession;
export const selectSessionsLoading = (state: RootState) => state.drbfm.sessionsLoading;
export const selectSessionsError = (state: RootState) => state.drbfm.sessionsError;
export const selectSessionsTotal = (state: RootState) => state.drbfm.sessionsTotal;

// Wizard selectors
export const selectWizardStep = (state: RootState) => state.drbfm.wizardStep;
export const selectInputData = (state: RootState) => state.drbfm.inputData;

// Analysis selectors
export const selectAnalysisProgress = (state: RootState) => state.drbfm.analysisProgress;
export const selectIsAnalyzing = (state: RootState) => state.drbfm.analysisProgress.isRunning;
export const selectCurrentFlowNumber = (state: RootState) => state.drbfm.analysisProgress.currentFlow;
export const selectOverallProgress = (state: RootState) => state.drbfm.analysisProgress.overallProgress;
export const selectFlowStatuses = (state: RootState) => state.drbfm.analysisProgress.flowStatuses;
export const selectAnalysisMessages = (state: RootState) => state.drbfm.analysisProgress.messages;
export const selectAnalysisError = (state: RootState) => state.drbfm.analysisProgress.error;

// Results selectors
export const selectAnalysisResults = (state: RootState) => state.drbfm.analysisResults;
export const selectDesignChanges = (state: RootState) => state.drbfm.analysisResults?.designChanges ?? [];
export const selectFailureModes = (state: RootState) => state.drbfm.analysisResults?.failureModes ?? [];
export const selectCountermeasures = (state: RootState) => state.drbfm.analysisResults?.countermeasures ?? [];

// Staged workflow selectors
export const selectWorkflow = (state: RootState) => state.drbfm.workflow;
export const selectWorkflowLoading = (state: RootState) => state.drbfm.workflowLoading;
export const selectWorkflowError = (state: RootState) => state.drbfm.workflowError;
export const selectWorkflowSession = (state: RootState) => state.drbfm.workflow?.session ?? null;
export const selectWorkflowArtifacts = (state: RootState) => state.drbfm.workflow?.artifacts ?? [];
export const selectWorkflowStageRuns = (state: RootState) => state.drbfm.workflow?.stageRuns ?? [];
export const selectWorkflowDesignChanges = (state: RootState) => state.drbfm.workflow?.designChanges ?? [];
export const selectWorkflowFailureModes = (state: RootState) => state.drbfm.workflow?.failureModes ?? [];
export const selectWorkflowCountermeasures = (state: RootState) => state.drbfm.workflow?.countermeasures ?? [];
export const selectWorkflowDecisionCards = (state: RootState) => state.drbfm.workflow?.decisionCards ?? [];

// Export selectors
export const selectIsExporting = (state: RootState) => state.drbfm.isExporting;
export const selectExportError = (state: RootState) => state.drbfm.exportError;

// Derived selectors
export const selectCanStartAnalysis = (state: RootState) => {
  try {
    analysisRequestFromInput(state.drbfm.inputData);
    return true;
  } catch {
    return false;
  }
};

export const selectSessionById = (sessionId: string) => (state: RootState) =>
  state.drbfm.sessions.find((s) => s.id === sessionId);

export const selectCompletedSessions = (state: RootState) =>
  state.drbfm.sessions.filter((s) => s.status === 'completed');

export const selectDraftSessions = (state: RootState) =>
  state.drbfm.sessions.filter((s) => s.status === 'draft');
